import React from 'react';
import { withStyles } from '@mui/styles';

import Node from '../../common/Node';
import Search from '../../common/Search';
import Loader from '../../common/Loader';
import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';
import TrplCheckbox from '../../common/TrplControls/TrplCheckbox';

import { getUrlParameter } from '../../utils';

const styles = {
  leftCol: {
    marginRight: '40px',
  },
  rightCol: {
    width: '400px',
  },
  ...CommonStyles,
};

class AncestorsPage extends ComponentWrapper {
  state = {
    isa: [],
    node: {
      id: 0,
      title: 'No title',
    },
    nodes: {},
    ako: false,
    loaded: false,
    ako_supers: [],
    interfaces: [],
    ioi: false,
  };
  componentDidMount() {
    document.title="Ancestors | Milkyweb";

    const iid = getUrlParameter('iid') || this.props.iid;
    const type = getUrlParameter('type') || this.props.type;

    this.get({
      url: `/get_node?id=${iid}`,
      cb: (res) => {
        this.setState({
          isa: res.data.isa,
          node: res.data.node,
          ako_supers: res.data.ako_supers,
          nodes: res.data.nodes,
          loaded: true,
          ako: type === 'ako',
          interfaces: res.data.node.box.i,
          ioi: type === 'ioi',
        });
      },
    });
  };

  onStateFieldChange = (key, value) => {
    this.setState({ [key]: value });
  };

  onSearchDropdownElementClick = (params) => {
    const nodeId = params.node.id;
    const { node, ako, ioi } = this.state;

    this.get({
      url: `/setanc?iid=${node.id}&cid=${nodeId}&type=${ako ? 'ako' : ioi ? 'ioi' : 'isa'}`,
      cb: () => {
        this.get({
          url: `/get_node?id=${node.id}`,
          cb: (res) => {
            this.setState({
              isa: res.data.isa,
              node: res.data.node,
              ako_supers: res.data.ako_supers,
              nodes: res.data.nodes,
              interfaces: res.data.node.box.i,
            });
          },
        });
      },
    });
  };

  removeConcept = (conceptId, index, type) => {
    const { node, isa, interfaces, ako_supers } = this.state;

    this.get({
      url: `/setanc?iid=${node.id}&cid=${conceptId}&type=${type}&remove=1`,
      cb: () => {
        if (type === 'isa') {
          isa.splice(index, 1);

          this.setState({ isa });
        } else if (type === 'ako') {
          ako_supers.splice(index, 1);

          this.setState({ ako_supers });
        } else {
          interfaces.splice(index, 1);

          this.setState({ interfaces });
        }
      },
    });
  };

  render() {
    const { classes, isEmbed } = this.props;
    const { interfaces, ioi, ako, isa, node, ako_supers, nodes, loaded } = this.state;

    return (
      <div>
        {!isEmbed ? <div className={`${classes.subHead} ${classes.mb20}`}>Add tag</div> : null}

        {loaded ? (
          <div className={classes.justifyCenter}>
            <div className={classes.leftCol}>
              <Node nodeId={node.id} isLink node={node} nodes={nodes} size="big" />

              <TrplCheckbox
                label="ISA"
                checked={!ako && !ioi}
                className={classes.mb10}
                onChange={(e) => {
                  this.onStateFieldChange('ako', !e.target.checked);
                  this.onStateFieldChange('ioi', !e.target.checked)
                }}
              />

              <div className={`${classes.column} ${classes.mb50}`}>
                {isa
                  ? isa.map((concept, conceptIndex) => {
                      return (
                        <Node
                          isLink
                          size="md"
                          isRemovable
                          nodeId={concept}
                          key={conceptIndex}
                          node={nodes[concept]}
                          nodes={nodes}
                          onRemoveClick={() => this.removeConcept(concept, conceptIndex, 'isa')}
                        />
                      );
                    })
                  : null}
              </div>

              <TrplCheckbox
                label="AKO"
                checked={ako}
                className={classes.mb10}
                onChange={(e) => {
                  this.onStateFieldChange('ako', e.target.checked);
                  this.onStateFieldChange('ioi', !e.target.checked)
                }}
              />

              <div className={`${classes.column} ${classes.mb50}`}>
                {ako_supers
                  ? ako_supers.map((concept, conceptIndex) => {
                      return (
                        <Node
                          isLink
                          size="md"
                          isRemovable
                          nodeId={concept}
                          key={conceptIndex}
                          node={nodes[concept]}
                          nodes={nodes}
                          onRemoveClick={() => this.removeConcept(concept, conceptIndex, 'ako')}
                        />
                      );
                    })
                  : null}
              </div>

              <TrplCheckbox
                label="INTERFACE"
                checked={ioi}
                className={classes.mb10}
                onChange={(e) => {
                  this.onStateFieldChange('ako', !e.target.checked);
                  this.onStateFieldChange('ioi', e.target.checked)
                }}
              />

              <div className={`${classes.column} ${classes.mb50}`}>
                {interfaces
                  ? interfaces.map((concept, conceptIndex) => {
                      return (
                        <Node
                          isLink
                          size="md"
                          isRemovable
                          nodeId={concept}
                          key={conceptIndex}
                          node={nodes[concept]}
                          nodes={nodes}
                          onRemoveClick={() => this.removeConcept(concept, conceptIndex, 'ioi')}
                        />
                      );
                    })
                  : null}
              </div>
            </div>

            <div className={classes.rightCol}>
              <Search
                conceptsOnly={true}
                containerStyles={{
                  width: '100%',
                  border: '1px solid lightgrey',
                  borderTop: '1px solid #BDBDBD',
                }}
                onDropdownElementClick={this.onSearchDropdownElementClick}
              />
            </div>
          </div>
        ) : (
          <div className={classes.justifyCenter}>
            <Loader />
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(AncestorsPage);
